import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Item = styled.li`
  width: 100%;
  list-style: none;
  display: flex;
  align-items: center;
  border-radius: ${p => p.theme.radii.medium};
  transition: ${p => p.theme.transition.main};

  @media (hover: hover) {
    &:hover {
      background: ${p => p.theme.brand.accentSoft};
    }
  }
`;

export const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 13px 16px;
  font-family: ${p => p.theme.fonts.body};
  font-weight: 600;
  font-size: 15px;
  color: ${p => p.theme.colors.textPrimary};
  transition: ${p => p.theme.transition.main};

  &.active {
    color: ${p => p.theme.colors.secondary};
  }
`;
